import "../../node_modules/@fortawesome/fontawesome-free/css/brands.css";
import "../../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css";
import "../../node_modules/@fortawesome/fontawesome-free/css/solid.css";
import { Game } from "./scripts/game";
import { initWalletFlow } from "./scripts/walletFlow";
import "./scss/pages/client.scss";

void Game.init();
void initWalletFlow();
